import React from 'react';
import './About.css';

const About = () => {
  const features = [
    {
      icon: 'fas fa-solar-panel',
      title: 'Đại diện thương hiệu',
      description: 'Đại diện chính thức pin lưu trữ HarveyPow và biến tần TechFine tại Việt Nam'
    },
    {
      icon: 'fas fa-box-open',
      title: 'Sản phẩm tích hợp',
      description: 'Bán buôn biến tần + pin lưu trữ được đấu nối và cài đặt sẵn phần mềm cho người tiêu dùng'
    },
    {
      icon: 'fas fa-tools',
      title: 'Thi công chuyên nghiệp',
      description: 'Chuyên thi công dự án năng lượng mặt trời cho khu công nghiệp cũng như hộ gia đình'
    },
    {
      icon: 'fas fa-shield-alt',
      title: 'Bảo hành 12 năm',
      description: 'Thời gian bảo hành sản phẩm chủ đạo lên đến 12 năm – điểm nổi bật vượt trội'
    }
  ];

  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6" data-aos="fade-right">
            <div className="about-image-wrapper">
              <div className="about-image-main">
                <img 
                  src="https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" 
                  alt="Kho hàng G-Nine Solar - Pin lưu trữ và biến tần"
                  className="img-fluid"
                />
              </div>
              <div className="about-image-secondary">
                <img 
                  src="https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" 
                  alt="Nhà máy sản xuất pin lưu trữ HarveyPow"
                  className="img-fluid"
                />
              </div>
              <div className="about-badge">
                <span className="badge-number">12</span>
                <span className="badge-text">Năm bảo hành</span>
              </div>
            </div>
          </div>

          <div className="col-lg-6" data-aos="fade-left">
            <div className="about-content">
              <span className="section-tag">VỀ CHÚNG TÔI</span>
              <h2 className="about-title">
                G-NINE SOLAR
              </h2>
              <p className="about-lead">
                <strong>G-Nine Solar</strong> là đơn vị chuyên về <strong>hệ thống năng lượng mặt trời uy tín chất lượng</strong>, 
                là đại diện của thương hiệu pin lưu trữ <strong>HarveyPow</strong> và biến tần <strong>TechFine</strong> tại Việt Nam.
              </p>
              <p className="about-description">
                Tại Việt Nam, chúng tôi chuyên <strong>bán buôn sản phẩm tích hợp</strong> bao gồm 
                biến tần + pin lưu trữ được đấu nối và cài đặt sẵn phần mềm cho người tiêu dùng. 
                Ngoài ra chúng tôi còn chuyên <strong>thi công các dự án năng lượng mặt trời</strong> cho 
                khu công nghiệp cũng như hộ gia đình. Bán buôn, bán lẻ các sản phẩm liên quan đến năng lượng mặt trời.
              </p>
              <p className="about-description">
                Chiến lược của chúng tôi là mang lại <strong>nguồn năng lượng xanh</strong> cho các hộ gia đình 
                Việt Nam với <strong>chi phí thấp nhất có thể, chất lượng tốt nhất</strong>, và sự chăm sóc nhiệt tình nhất, 
                hướng tới phủ kín bản đồ Việt Nam về sản phẩm tích hợp năng lượng mặt trời mang tính 
                <strong> bền – đẹp – giá thành hợp lý</strong>.
              </p>

              <div className="about-features">
                {features.map((feature, index) => (
                  <div key={index} className="feature-item" data-aos="fade-up" data-aos-delay={index * 100}>
                    <div className="feature-icon">
                      <i className={feature.icon}></i>
                    </div>
                    <div className="feature-content">
                      <h4>{feature.title}</h4>
                      <p>{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="about-cta">
                <a href="#contact" className="btn btn-primary">
                  Tìm hiểu thêm
                  <i className="fas fa-arrow-right ms-2"></i>
                </a>
                <a href="tel:0989786995" className="btn btn-outline-secondary">
                  <i className="fas fa-phone-alt me-2"></i>
                  0989.786.995 - 0983.913.951
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;